@if (link?.sheet) {
  <div class="context-chips" data-testid="design-context-chips">
    <span class="context-chip" data-testid="design-context-chip-sheet" [attr.aria-label]="sheetLabel">
      <mat-icon aria-hidden="true">description</mat-icon>{{ sheetText }}
    </span>
    @if (hasLocation) {
      <span class="context-chip" data-testid="design-context-chip-location" aria-label="Map location">
        <mat-icon aria-hidden="true">place</mat-icon>Location
      </span>
    }
  </div>
}
